import * as React from 'react';
import { SVGProps } from 'react';
export const Help = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden={true}
    focusable={false}
    {...props}
  >
    <path
      d="M10.293 7.673c1.575-.697 3.613-.614 4.309.513.696 1.126.215 2.436-.978 3.447-1.193 1.011-1.623 1.56-1.623 2.355M12 16.804v.009M22.5 12c0 5.799-4.701 10.5-10.5 10.5S1.5 17.799 1.5 12 6.201 1.5 12 1.5 22.5 6.201 22.5 12Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
